import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Opportunities from './pages/Opportunities';
import TenderSupport from './pages/TenderSupport';
import Jobs from './pages/Jobs';
import Contact from './pages/Contact';
import LegalPage from './pages/LegalPage';
import WhatsAppButton from './components/WhatsAppButton';
import { sendDeploymentPing } from './lib/api';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  useEffect(() => { sendDeploymentPing(); }, []);
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/opportunities" element={<Opportunities />} />
              <Route path="/tender-support" element={<TenderSupport />} />
              <Route path="/jobs" element={<Jobs />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<LegalPage type="privacy" />} />
              <Route path="/terms" element={<LegalPage type="terms" />} />
              <Route path="/disclaimer" element={<LegalPage type="disclaimer" />} />
              <Route path="/cookie-policy" element={<LegalPage type="cookie" />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
